import { Cache } from '@stt-componentes/cache';
import axios from 'axios';

export const getHeaders = () => {
    const token = Cache.getAccessToken();
    return { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' };
};

export const pingServidorStt = async (pacs_aetitle) => {
    return axios.post(`${global.gConfig.url_base_gestao_pacs}/servicos-pacs/stt/ping`, { pacs_aetitle }, { headers: getHeaders() });
};

export const pingServidorBridge = async (bridge_aetitle) => {
    return axios.post(`${global.gConfig.url_base_gestao_pacs}/servicos-pacs/bridge/ping`, { bridge_aetitle }, { headers: getHeaders() });
};

export const consultarVolumeCuboPacs = async ({ pacs_aetitle, bridge_aetitle }) => {
    return axios.get(`${global.gConfig.url_base_gestao_pacs}/servicos-pacs/cubo/volume`, {
        params: { pacs_aetitle, bridge_aetitle },
        headers: getHeaders(),
    });
};

export const alterarCheckpointCuboPacs = async (dados) => {
    return axios.post(`${global.gConfig.url_base_gestao_pacs}/servicos-pacs/cubo/checkpoint`, dados, { headers: getHeaders() });
};

export const listarDadosFormularioBridge = async () => {
    return axios.get(`${global.gConfig.url_base_gestao_pacs}/servicos-pacs/bridge/form-data`, { headers: getHeaders() });
};

export const listarBridgesExecutaveis = async () => axios.get(`${global.gConfig.url_base_gestao_pacs}/servicos-pacs/dicom-hub-pacs/bridges`, { headers: getHeaders() });
export const cadastrarBridgeExecutavel = async (dados) => axios.post(`${global.gConfig.url_base_gestao_pacs}/servicos-pacs/dicom-hub-pacs/bridges`, dados, { headers: getHeaders() });
export const listarInstituicoesServidorPacs = async () => axios.get(`${global.gConfig.url_base_gestao_pacs}/servicos-pacs/dicom-hub-pacs/instituicoes`, { headers: getHeaders() });
export const buscarInstituicaoExecutavelPorCnes = async (cnes) => axios.get(`${global.gConfig.url_base_gestao_pacs}/servicos-pacs/dicom-hub-pacs/instituicoes/cnes/${cnes}`, { headers: getHeaders() });
export const buscarDetalheBridgeExecutavel = async (idBridge, { signal } = {}) => axios.get(`${global.gConfig.url_base_gestao_pacs}/servicos-pacs/dicom-hub-pacs/bridges/${idBridge}`, { headers: getHeaders(), signal });
export const revogarDispositivoBridgeExecutavel = async (idBridge, idDispositivo) => axios.delete(`${global.gConfig.url_base_gestao_pacs}/servicos-pacs/dicom-hub-pacs/bridges/${idBridge}/dispositivos/${idDispositivo}`, { headers: getHeaders() });
export const reativarDispositivoBridgeExecutavel = async (idBridge, idDispositivo) => axios.put(`${global.gConfig.url_base_gestao_pacs}/servicos-pacs/dicom-hub-pacs/bridges/${idBridge}/dispositivos/${idDispositivo}/reativar`, {}, { headers: getHeaders() });

// Configuração do Visualizador por bridge (aba Visualizador, administrativa). A senha nunca
// volta do backend: o formulário recebe só `tem_senha`, e em branco significa "manter a atual".
export const buscarConfiguracaoVisualizador = async (idBridge) =>
    axios.get(`${global.gConfig.url_base_gestao_pacs}/servicos-pacs/visualizador/bridges/${idBridge}/configuracao`, { headers: getHeaders() });
export const salvarConfiguracaoVisualizador = async (idBridge, dados) =>
    axios.put(`${global.gConfig.url_base_gestao_pacs}/servicos-pacs/visualizador/bridges/${idBridge}/configuracao`, dados, { headers: getHeaders() });

export const listarBridgesVisualizador = async () =>
    axios.get(`${global.gConfig.url_base_gestao_pacs}/servicos-pacs/visualizador/bridges`, { headers: getHeaders() });
export const listarInstalacoesVisualizador = async (idBridge, { signal } = {}) =>
    axios.get(`${global.gConfig.url_base_gestao_pacs}/servicos-pacs/visualizador/bridges/${idBridge}/instalacoes`, { headers: getHeaders(), signal });
export const revogarInstalacaoVisualizador = async (idBridge, idInstalacao) =>
    axios.delete(`${global.gConfig.url_base_gestao_pacs}/servicos-pacs/visualizador/bridges/${idBridge}/instalacoes/${idInstalacao}`, { headers: getHeaders() });
export const reativarInstalacaoVisualizador = async (idBridge, idInstalacao) =>
    axios.put(`${global.gConfig.url_base_gestao_pacs}/servicos-pacs/visualizador/bridges/${idBridge}/instalacoes/${idInstalacao}/reativar`, {}, { headers: getHeaders() });
// O desbloqueio chega à estação na próxima sincronização de auditoria, não na hora (ADR-0006).
export const permitirAcessoVisualizador = async (cpf, dados) =>
    axios.put(`${global.gConfig.url_base_gestao_pacs}/servicos-pacs/visualizador/usuarios/${encodeURIComponent(cpf)}/permitir-acesso`, dados, { headers: getHeaders() });

export const buscarBridgePorId = async (id) => {
    return axios.get(`${global.gConfig.url_base_gestao_pacs}/servicos-pacs/bridge/${id}`, { headers: getHeaders() });
};

export const cadastrarBridge = async (dados) => {
    return axios.post(`${global.gConfig.url_base_gestao_pacs}/servicos-pacs/bridge`, dados, { headers: getHeaders() });
};

export const atualizarBridge = async (id, dados) => {
    return axios.put(`${global.gConfig.url_base_gestao_pacs}/servicos-pacs/bridge/${id}`, dados, { headers: getHeaders() });
};

export const buscarInstituicaoPacsSttPorCnes = async (cnes) => {
    return axios.get(`${global.gConfig.url_base_gestao_pacs}/servicos-pacs/stt/instituicao-cnes/${cnes}`, { headers: getHeaders() });
};

export const validarAetitlePacsStt = async (dados) => {
    return axios.post(`${global.gConfig.url_base_gestao_pacs}/servicos-pacs/stt/validar-aetitle`, dados, { headers: getHeaders() });
};

export const cadastrarPacsStt = async (dados) => {
    return axios.post(`${global.gConfig.url_base_gestao_pacs}/servicos-pacs/stt`, dados, { headers: getHeaders() });
};

export const buscarPacsSttPorUrlBase = async (urlBase) => {
    return axios.get(`${global.gConfig.url_base_gestao_pacs}/servicos-pacs/stt/dados/${encodeURIComponent(urlBase)}`, { headers: getHeaders() });
};

export const atualizarPacsStt = async (urlBase, dados) => {
    return axios.put(`${global.gConfig.url_base_gestao_pacs}/servicos-pacs/stt/${encodeURIComponent(urlBase)}`, dados, { headers: getHeaders() });
};

export const buscarYamlPacsStt = async (urlBase) => {
    return axios.get(`${global.gConfig.url_base_gestao_pacs}/servicos-pacs/stt/yaml/${encodeURIComponent(urlBase)}`, { headers: getHeaders() });
};

export const buscarYamlBridge = async (id) => {
    return axios.get(`${global.gConfig.url_base_gestao_pacs}/servicos-pacs/bridge/${id}/yaml`, { headers: getHeaders() });
};

export const gerarUrlUpload = async (filename) => {
    return axios.post(`${global.gConfig.url_base_gestao_pacs}/servicos-pacs/bridge/estudos-dicom/upload-url`, { filename }, { headers: getHeaders() });
};

export const confirmarUpload = async (objectName) => {
    return axios.post(`${global.gConfig.url_base_gestao_pacs}/servicos-pacs/bridge/estudos-dicom/confirmar-upload`, { objectName }, { headers: getHeaders() });
};

export const criarEstudoDicom = async (dados) => {
    return axios.post(`${global.gConfig.url_base_gestao_pacs}/servicos-pacs/bridge/estudos-dicom`, dados, { headers: getHeaders() });
};

export const verificarStatusEstudo = async (jobId) => {
    return axios.get(`${global.gConfig.url_base_gestao_pacs}/servicos-pacs/bridge/estudos-dicom/status/${jobId}`, { headers: getHeaders() });
};

export const renomearEstudoDicom = async (dados) => {
    return axios.post(`${global.gConfig.url_base_gestao_pacs}/servicos-pacs/bridge/estudos-dicom/renomear`, dados, { headers: getHeaders() });
};

export const verificarStatusRenomeacao = async (jobId) => {
    return axios.get(`${global.gConfig.url_base_gestao_pacs}/servicos-pacs/bridge/estudos-dicom/renomear/status/${jobId}`, { headers: getHeaders() });
};

export const resolverAlerta = async (alertaId, acao) => {
    return axios.put(`${global.gConfig.url_base_gestao_pacs}/visao-geral/alertas-resolver/${alertaId}`, { acao }, { headers: getHeaders() });
};

export const excluirAlertasLote = async (ids) =>
    axios.post(`${global.gConfig.url_base_gestao_pacs}/visao-geral/alertas-excluir-lote`, { ids }, { headers: getHeaders() });

export const listarLotesExclusao = async ({ signal } = {}) =>
    axios.get(`${global.gConfig.url_base_gestao_pacs}/visao-geral/alertas-excluir-lote`, { headers: getHeaders(), signal });

export const obterLoteExclusao = async (loteId, { signal } = {}) =>
    axios.get(`${global.gConfig.url_base_gestao_pacs}/visao-geral/alertas-excluir-lote/${encodeURIComponent(loteId)}`, { headers: getHeaders(), signal });

export const buscarExamesEstudoAlerta = async (alertaId) => {
    return axios.get(`${global.gConfig.url_base_gestao_pacs}/visao-geral/alertas/${alertaId}/exames-estudo`, { headers: getHeaders() });
};

export const monitorarExclusaoAlerta = async (alertaId, comandoId) => {
    return axios.get(`${global.gConfig.url_base_gestao_pacs}/visao-geral/alertas-status-exclusao/${alertaId}/${comandoId}`, { headers: getHeaders() });
};

export const restaurarAlerta = async (alertaId) => {
    return axios.put(`${global.gConfig.url_base_gestao_pacs}/visao-geral/alertas-restaurar/${alertaId}`, {}, { headers: getHeaders() });
};

export const monitorarRestauracaoAlerta = async (alertaId, comandoId) => {
    return axios.get(`${global.gConfig.url_base_gestao_pacs}/visao-geral/alertas-status-restauracao/${alertaId}/${comandoId}`, { headers: getHeaders() });
};

export const listarInstituicoesFiltroAlertas = async () => {
    return axios.get(`${global.gConfig.url_base_gestao_pacs}/visao-geral/alertas/filtros/instituicoes`, { headers: getHeaders() });
};

export const enviarNovamenteComando = async (dadosComando) => {
    return axios.post(`${global.gConfig.url_base_gestao_pacs}/comandos/enviar-novamente`, dadosComando, { headers: getHeaders() });
};

export const listarDicomHubVersoes = async (app = 'visualizador', plataforma = 'windows', ambiente) => {
    return axios.get(`${global.gConfig.url_base_gestao_pacs}/dicom-hub/versoes`, { params: { app, plataforma, ambiente }, headers: getHeaders() });
};

export const obterUrlDownloadDicomHub = async (versao, tipo = 'exe', app = 'visualizador', plataforma = 'windows', ambiente) => {
    return axios.get(`${global.gConfig.url_base_gestao_pacs}/dicom-hub/versoes/${encodeURIComponent(versao)}/download`, {
        params: { tipo, app, plataforma, ambiente },
        headers: getHeaders(),
    });
};

// Filtros aceitos: app, plataforma e ambiente. A grid da aba Apps manda sempre o
// ambiente do deploy (ADR-0014); sem filtro nenhum a rota lista tudo, como antes.
export const listarDicomHubVersoesAdmin = async (filtros = {}) => {
    return axios.get(`${global.gConfig.url_base_gestao_pacs}/dicom-hub/admin/versoes`, { params: filtros, headers: getHeaders() });
};

export const gerarUrlUploadDicomHub = async (dados) => {
    return axios.post(`${global.gConfig.url_base_gestao_pacs}/dicom-hub/admin/versoes/upload-url`, dados, { headers: getHeaders() });
};

export const confirmarUploadDicomHub = async (dados) => {
    return axios.post(`${global.gConfig.url_base_gestao_pacs}/dicom-hub/admin/versoes/confirmar-upload`, dados, { headers: getHeaders() });
};

// `ambiente` sem default: a remoção precisa dizer de qual ambiente é o artefato, ou o
// backend acerta um documento arbitrário quando a mesma versão existe em dois (ADR-0014).
export const removerArtefatoDicomHub = async (versao, tipo, motivo, app = 'visualizador', plataforma = 'windows', ambiente) => {
    return axios.delete(`${global.gConfig.url_base_gestao_pacs}/dicom-hub/admin/versoes/${encodeURIComponent(versao)}/artefatos/${tipo}`, {
        headers: getHeaders(),
        data: { motivo, app, plataforma, ambiente },
    });
};

const obterUrlBasePublico = () => {
    return (
        global.gConfig?.url_base_gestao_pacs_public ||
        global.gConfig?.url_base_gestao_pacs?.replace(/\/gestao-pacs$/, '/gestao-pacs-public') ||
        '/gestao-pacs-public'
    );
};

// ==========================================
// Rotas STT App Mobile (T07 - Admin / T08 - Público)
// ==========================================

// T08 - Listagem pública de versões ativas do APK
export const listarSttAppVersoesPublicas = async () => {
    const urlBase = obterUrlBasePublico();
    return axios.get(`${urlBase}/app/versoes`);
};

// T08 - URL pré-assinada para download público do APK (aceita 'latest' ou semver)
export const obterUrlDownloadSttAppPublica = async (versao = 'latest') => {
    const urlBase = obterUrlBasePublico();
    return axios.get(`${urlBase}/app/versoes/${encodeURIComponent(versao)}/download`, {
        params: { tipo: 'apk' },
    });
};

// T07 - Listagem administrativa de versões do STT App
export const listarSttAppVersoesAdmin = async (filtros = {}) => {
    return axios.get(`${global.gConfig.url_base_gestao_pacs}/stt-app/admin/versoes`, {
        params: filtros,
        headers: getHeaders(),
    });
};

// T07 - Gerar URL pré-assinada de upload de APK
export const gerarUrlUploadSttApp = async (dados) => {
    return axios.post(`${global.gConfig.url_base_gestao_pacs}/stt-app/admin/versoes/upload-url`, dados, {
        headers: getHeaders(),
    });
};

// T07 - Confirmar publicação de APK no backend
export const confirmarUploadSttApp = async (dados) => {
    return axios.post(`${global.gConfig.url_base_gestao_pacs}/stt-app/admin/versoes/confirmar-upload`, dados, {
        headers: getHeaders(),
    });
};

// T07 - Remoção (soft delete) de APK com motivo
export const removerArtefatoSttApp = async (versao, motivo) => {
    return axios.delete(
        `${global.gConfig.url_base_gestao_pacs}/stt-app/admin/versoes/${encodeURIComponent(versao)}/artefatos/apk`,
        {
            headers: getHeaders(),
            data: { motivo },
        }
    );
};

